import { Heading, Icon, Text, TextButton, Upsell } from '@zillow/constellation-10';
import { IconFileFilled } from '@zillow/constellation-icons';
import { useCappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus } from '@zg-rentals/ts-capps-client-react-query';
import { PlaidIncomeVerificationWebhookStatus } from '@zg-rentals/ts-capps-client';
import Link from 'next/link';
import { formatDate } from '@zg-rentals/formatters';

export function IncomeReportUpsell() {
  const { data } = useCappsRenterIncomeVerificationWebApiHandler_getIncomeVerificationReportStatus({
    meta: { tags: ['incomeReport'] },
  });

  const reportStatus = data?.reportStatus;
  const isReportReady = reportStatus?.webhookStatus === PlaidIncomeVerificationWebhookStatus.REPORT_READY;
  const isReportExpired = reportStatus?.expiresAt != null && reportStatus.expiresAt < Date.now();
  if (!isReportReady || isReportExpired) {
    return null;
  }

  return (
    data && (
      <Upsell
        header={
          <Heading level={2} textStyle="body-lg-bold">
            Income verification
          </Heading>
        }
        body={<Text>Verified by Plaid on {formatDate(data.reportStatus.reportGeneratedAt)}.</Text>}
        media={
          <Icon>
            <IconFileFilled />
          </Icon>
        }
        action={
          <TextButton asChild>
            <Link href="/income-report">View your report</Link>
          </TextButton>
        }
        closeable={false}
        elevated={false}
      />
    )
  );
}
